import { useI18n } from '@cascade/react/i18n';
import { TagsGate as SharedTagsGate } from '@cascade/react/projects';
import type { PropsWithChildren } from 'react';
import { Layout } from '#layout/index.ts';
import { RequiredTags } from '#views/required-tags/index.ts';

export const TagsGate = ({ children }: PropsWithChildren) => {
  const { translate } = useI18n();

  return (
    <SharedTagsGate
      loading={
        <Layout mode='card' title={translate('pending.tags')} isLoading />
      }
      incomplete={<RequiredTags />}
    >
      {children}
    </SharedTagsGate>
  );
};
